export const drawModelLabel = (model) => {
    return model.name;
};
